export const CLIENTS_PAGE_SIZE = 20;
